const { CanvasGearMergeApp } = require('../games/merge/canvasGearMergeApp')
const { WebGameApi } = require('./webGameApi')
const { RoiifyBanner } = require('./roiifyBanner')
const { AdbutInterstitial } = require('./adbutInterstitial')

const config = globalThis.GEAR_MERGE_CONFIG || {}
const adbut = new AdbutInterstitial(config.adbut || {})
const adbutConfigured = adbut.prepare()
const banner = new RoiifyBanner(config.roiify || {})

if (!adbutConfigured) banner.prepare()

const queryRound = Number(new URLSearchParams(globalThis.location?.search || '').get('round'))
const configuredRound = Number(config.game?.round)
const round = Number.isFinite(queryRound) && queryRound > 0
  ? queryRound
  : Number.isFinite(configuredRound) && configuredRound > 0
    ? configuredRound
    : 1
const rawSeed = config.game?.seed
const seed = rawSeed === null || rawSeed === undefined || rawSeed === ''
  ? undefined
  : Number(rawSeed)
const web = new WebGameApi()
const app = new CanvasGearMergeApp(web, {
  adbut,
  round,
  seed: Number.isFinite(seed) ? seed : undefined
})

app.mount().catch((error) => {
  console.error('[Gear Merge] Failed to start:', error)
  const errorElement = document.getElementById('game-error')
  if (errorElement) {
    errorElement.textContent = 'The forge failed to start. Please refresh and try again.'
    errorElement.hidden = false
  }
})

if (!adbutConfigured) banner.load()
